(function(angular) {
    'use strict';

    angular.module('inboundRules')

    /**
     *
     */
    .factory('inboundRulesData', 
        ['$q', '$state', 'customChannelService', 'facebookService', 'teamSettingsService', 'inboundService', 'emailSettingsService', 'profileHelper', 'profilesService', 'whatsAppServices', 'rcsServices', 'permittedChannels',
        function ($q, $state, customChannelService, facebookService, teamSettingsService, inboundService, emailSettingsService, profileHelper, profilesService, whatsAppServices, rcsServices, permittedChannels) {
        
        var data = {};
        function onError(result){
            var deferred = $q.defer();
            if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
            return deferred.promise;
        }
        var fac = {
            data: data,

            generateData: function(){
                var promises = [];

                if(!data.availableChannels){
                    promises.push(customChannelService.getChannels($state.toParams.pickedApiSpaceId)
                        .then(function (result) {
                            data.availableChannels = result;
                            return $q.resolve();
                        }).catch(onError));
                }

                if(!data.fbPages){
                    promises.push(facebookService.getPageFromComapi($state.toParams.pickedApiSpaceId)
                        .then(function (result) {
                            data.fbPages = result;
                            return $q.resolve();
                        }).catch(onError));
                }

                if(!data.teams){
                    promises.push(teamSettingsService.getTeams($state.toParams.pickedApiSpaceId)
                        .then(function (result) {
                            data.teams = result;
                            return $q.resolve();
                        }).catch(onError));
                }

                if (!data.inboundNumbers) {
                    promises.push(inboundService.getDedicatedNumbers($state.toParams.pickedApiSpaceId)
                        .then(function (result) {
                            data.inboundNumbers = result;
                            if (!data.shortCodes) {
                                return inboundService.getKeywords($state.toParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        data.shortCodes = result;

                                        if (!_.isEmpty(data.shortCodes)){
                                            // add a label field for display purposes
                                            data.shortCodes = data.shortCodes.map(item=>{
                                                item.name = item.number;
                                                return item;
                                            });
                                        }

                                        if (_.isEmpty(data.inboundNumbers)) { data.inboundNumbers = [] }

                                        // add a label field for display purposes
                                        data.inboundNumbers = data.inboundNumbers.map(item=>{
                                            item.name = item.number;
                                            return item;
                                          });

                                        data.inboundNumbers = data.inboundNumbers.concat(_.uniqBy(data.shortCodes, 'number'));
                                    }).catch(onError);
                            }
                            return $q.resolve();
                        }).catch(onError));
                }

                if(!data.email){
                    promises.push(emailSettingsService.getEmailSettings($state.toParams.pickedApiSpaceId)
                        .then(function (result) {
                            data.email = result;
                            return $q.resolve();
                        }).catch(onError));
                }
                if(!data.whatsApp){
                    if(permittedChannels.canRead('whatsApp')){
                        promises.push(whatsAppServices.getAllWhatsAppConfigurations($state.toParams.pickedApiSpaceId)
                            .then(function (result) {
                                data.whatsApp = result;
                                return $q.resolve();
                            }).catch(onError));
                    }
                }
                if(!data.rcs){
                    if(permittedChannels.canRead('rcs')){
                        promises.push(rcsServices.getAllRcsConfigurations($state.toParams.pickedApiSpaceId)
                        .then((result) => {
                            data.rcs = result
                            return $q.resolve();
                        }).catch(onError));
                    }
                }

                if(!data.profileSchema){
                    var deferred = $q.defer();
                    promises.push(deferred.promise);

                    var profileSchema = [];
                    if (!profileHelper.getSchema().length) {
                        profilesService.getProfileSchema($state.toParams.pickedApiSpaceId)
                            .then(function (result) {
                                profileHelper.setSchema(result);
                                result = profileHelper.getSchema();
                                for (var i in result) {
                                    if (!result[i].onlyObjects && !result[i].name.startsWith('data.') && result[i].name != 'id') {
                                        profileSchema.push(result[i]);
                                    }
                                }
                                data.profileSchema = profileSchema;
                                deferred.resolve();
                            }).catch(onError);
                    }
                    else {
                        var schema = profileHelper.getSchema();
                        for (var i in schema) {
                            if (!schema[i].onlyObjects && !schema[i].name.startsWith('data.') && schema[i].name != 'id') {
                                profileSchema.push(schema[i]);
                            }
                        }
                        data.profileSchema = profileSchema;
                        deferred.resolve();
                    }
                }
                return $q.all(promises);
            }
        };

        return fac;



    }]);
})(window.angular);
